export default __webpack_public_path__ + "static/media/gradient_bottom.21756d38.svg";